import { Check, CheckCheck, Clock, TriangleAlert } from 'lucide-react'
import type { DeliveryState } from '@/entities/chat'
import { cn } from '@/shared/lib/utils'

const LABEL: Record<DeliveryState, string> = {
  pending: 'Sending',
  sent: 'Sent',
  delivered: 'Delivered',
  read: 'Read',
  failed: 'Not sent',
}

export function DeliveryTicks({ state, onClick }: { state: DeliveryState; onClick?: () => void }) {
  const icon =
    state === 'pending' ? (
      <Clock size={12} className="text-ink-4" />
    ) : state === 'failed' ? (
      <TriangleAlert size={12} className="text-bad" />
    ) : state === 'sent' ? (
      <Check size={12} className="text-ink-4" />
    ) : (
      <CheckCheck size={12} className={state === 'read' ? 'text-brand-accent' : 'text-ink-4'} />
    )

  if (!onClick) {
    return (
      <span aria-label={LABEL[state]} className="inline-flex items-center">
        {icon}
      </span>
    )
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={LABEL[state]}
      title={LABEL[state]}
      className={cn('inline-flex items-center rounded-sm p-0.5 hover:bg-hover')}
    >
      {icon}
    </button>
  )
}
